<template>
    <DefaultHeader />
    <section class="vh-auto">
        <div class="container h-100">
            <div class="row d-flex justify-content-center align-items-center h-100">
                <div class="col col-lg-12 mb-4 mb-lg-0">
                    <div class="card mb-3 shadow p-3 mb-5 bg-body rounded" style="border-radius: .5rem;">
                        <div class="card-body p-4">
                            <div class="row align-items-center mb-2">
                                <div class="col">
                                    <h5>
                                        {{ (mission?.name || 'Nouvelle mission') }} : préparation mission
                                        <span class="badge rounded-pill bg-warning text-dark">En cours</span>
                                    </h5>
                                </div>
                                <!-- Actions d'en-tête (ex: lien tutoriel) -->
                                <div class="col-auto d-flex align-items-center gap-2">
                                    <a v-if="tutorialLink" :href="tutorialLink" target="_blank"
                                        rel="noopener noreferrer" class="btn btn-outline-secondary btn-sm">
                                        <font-awesome-icon :icon="['fas', 'circle-info']" class="me-1" />
                                        Aide
                                    </a>
                                    <slot name="header-actions" />
                                </div>
                            </div>

                            <hr class="mb-4 mt-0" />

                            <!-- ⚠️ Avertissement global quand la mission est EN COURS -->
                            <div v-if="mission && mission.status === 'ONGOING'" class="alert alert-danger mb-4"
                                role="alert">
                                ⚠️ Cette mission est <strong>EN COURS</strong> : certaines modifications sont
                                verrouillées. Toute modification sera enregistrée.
                            </div>

                            <!-- Contenu spécifique à l'étape -->
                            <slot />

                            <!-- Actions (boutons) -->
                            <div class="row pt-1 mb-5 d-flex justify-content-end">
                                <div class="col-auto">
                                    <slot name="actions" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'

export default {
    name: 'WizardShell',
    props: {
        mission: { type: Object, default: null },
    },
    components: { DefaultHeader, DefaultFooter },
    computed: {
        tutorialLink() {
            return this.$route?.meta?.tutorialLink || '';
        }
    }
}
</script>
